import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ProgressBar } from "react-loader-spinner";

import Cookies from "js-cookie";

import InputsCreatorUniversal from "../../../hooks/inputCreatorUniversal";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import UniversalInputComponent from "../commonComponents/universalInputComponent/UniversalInputComponent";
import OtherInformationRHF from "../commonComponents/otherInformationRHF/OtherInformationRHF";
import TableAppBoatRegRHF from "../commonComponents/tableAppBoatRegRHF/TableAppBoatRegRHF";
import AppFooterRHF from "../commonComponents/appFooterRHF/AppFooterRHF";
import ButtonsBlock from "../../GeneralComponents/buttonsBlock/ButtonsBlock";
import ResultModalWindow from "../commonComponents/ResultModalWindow/ResultModalWindow";
import QRModalWindow from "../commonComponents/QRModalWindow/QRModalWindow";
import ModalWindowWithInputs from "../../GeneralComponents/modalWindowWithInputs/modalWindowWithInputs";

import {
  deleteDataFromIndexedDB,
  logIndexedDBData,
  saveDataToIndexedDB,
} from "../../../services/indexedDBService";

import {
  interestedIndividual,
  interestedEntity,
  representPerson,
  boatInfo,
  boatCardAppEngDtoList,
  boatCardAppDealsDtoList,
  boatCardAppSmDtoList,
  setOptionsEngType,
  setOptionsRepresentPerson,
  setOptionsInterestedPerson,
  setDocOptionsDocumentsFromDictionariesInterested,
  setDocOptionsDocumentsFromDictionariesRepresent,
  setOblOptionsFromDictionariesInterested,
  setOblOptionsFromDictionariesRepresent,
  setOptionsForBoat,
  clearOptions,
  setGridsByMode,
  setDefaultOptionsRepresent,
  toggleSearchButton,
  toggleRequiredEngPowerByEngineNum,
  isNeedToPaySelector,
  setDefaultOptions,
  setButtonVisibilityByAccess,
  setMidnameRequiredByDocType,
  boatCardAppEngStaticDtoList,
  toggleEngDtoListRequired,
  optionsForPasswordModal,
  toggleRequiredEngPowerByBoatType,
} from "./optionsAppBoatRegistrationRHF";

import {
  clearEnginesTable,
  clearNewStatement,
  getBoatRegInfo,
} from "../../../redux/statementReducer/actionsStatement";

import { fetchWithToken } from "../../../interceptors/fetchInterceptor";

import {
  API_ADD_NEW_STATEMENT,
  API_ADD_STATEMENT_PROVISION_INFORMATION,
  API_CHECK_POSSIBILITY_SAVING_APP,
  API_FOR_AVEST_SIGN,
  API_GET_BILL,
  API_GET_BOAT_INFO_BY_VIN,
  API_GET_INFO_BY_PERS_NUM,
  API_GET_INFO_BY_PERS_NUM_WITH_SIGN,
  API_GET_INFO_BY_REG_NUM,
  API_GET_QR,
  API_PRINT_STATEMENT_BOAT,
  MAIN_URL,
  PORT,
  PORT_FOR_INTEGRATION,
} from "../../../constants/constants";

import styles from "./appBoatRegistrationRHF.module.css";

const storeName = "boatRegistration";

export default function AppBoatRegistrationRHF() {
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
    setError,
    getValues,
    trigger,
    reset,
  } = useForm({ mode: "onChange" });

  const {
    register: registerModal,
    handleSubmit: handleSubmitModal,
    control: controlModal,
    formState: { errors: errorsModal },
    setValue: setValueModal,
    getValues: getValuesModal,
    reset: resetModal,
  } = useForm({ mode: "onChange" });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const mode = window.location.pathname.includes("app") ? "add" : "view";
  const downloadAPI = "http://gims-dev.compit.by:8080/boatCardApp/download/";
  const personTypeByPath = window.location.pathname.includes("individual") ? 1 : 2;
  const userId = Cookies.get("userId");

  const [options, setOptions] = useState({
    interested: window.location.pathname.includes("individual") ? interestedIndividual : interestedEntity,
    represent: representPerson,
    boatInfo: boatInfo,
  });

  const [tableOptions, setTableOptions] = useState({
    boatCardAppEngDtoList: boatCardAppEngDtoList,
    boatCardAppDealsDtoList: boatCardAppDealsDtoList,
    boatCardAppSmDtoList: boatCardAppSmDtoList,
    boatCardAppEngStaticDtoList: boatCardAppEngStaticDtoList,
  });
  const [localPersonType, setLocalPersonType] = useState(
    mode === "add" ? (window.location.pathname.includes("individual") ? 1 : 2) : null,
  );
  const [isLoading, setIsLoading] = useState(true);
  const [newData, setNewData] = useState({
    appDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
    isNeedToPaySelector: false,
  });

  const [file, setFile] = useState("");
  const [viewFileName, setViewFileName] = useState("");
  const [showResultModal, setShowResultModal] = useState(false);
  const [registrationResult, setRegistrationResult] = useState("");
  const [appId, setAppId] = useState(null);
  const [errorText, setErrorText] = useState("");
  const [headerText, setHeaderText] = useState("");
  const [showBillContractModal, setShowBillContractModal] = useState(false);
  const [serviceBill, setServiceBill] = useState(null);
  const [tablesErrors, setTablesErrors] = useState({
    boatCardAppEngDtoList: "",
    boatCardAppDealsDtoList: "",
    boatCardAppSmDtoList: "",
    boatCardAppEngStaticDtoList: "",
  });
  const [isPrinted, setIsPrinted] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [buttonType, setButtonType] = useState("");
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [indexedDBData, setIndexedDBData] = useState(null);

  const statementReducer = useSelector((state) => {
    const { statementReducer } = state;
    return statementReducer;
  });

  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });

  const searchAccess = useChapterActionIdMatch(sortedMenuNames?.SMALL_BOATS_REG?.searchEGR?.chapterActionId);
  const printAccess = useChapterActionIdMatch(
    sortedMenuNames?.SMALL_BOATS_REG?.printApplication?.chapterActionId,
  );

  const handleFile = (e) => {
    if (e) {
      if (e.target.files[0]) {
        setFile(e.target.files[0]);
      }
    }
  };

  const clearFile = (e) => {
    setFile("");
    e.preventDefault();
  };

  const handleEngPower = (value, name) => {
    const newValue = value?.includes(",") ? value.replace(",", ".") : value;
    if (!newValue) {
      setValue(name === "engpwrmax" ? "engpwrmaxkwt" : "engpwrmax", "");
    } else {
      if (name === "engpwrmaxkwt") {
        if (Math.round(Number(newValue))) {
          setValue("engpwrmax", Math.round(Number(newValue) * 1.3595));
          clearErrors("engpwrmaxkwt");
        } else {
          setValue("engpwrmax", "");
          setError("engpwrmaxkwt", {
            type: "manual",
            message: "Введите число",
          });
        }
      } else {
        if (Math.round(Number(newValue))) {
          setValue("engpwrmaxkwt", (Number(newValue) / 1.3595).toFixed(1));
          clearErrors("engpwrmax");
        } else {
          setValue("engpwrmaxkwt", "");
          setError("engpwrmax", { type: "manual", message: "Введите число" });
        }
      }
    }
  };
  const handleCloseApp = () => {
    setFile(null);
    setNewData(
      structuredClone({
        appDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
      }),
    );
    dispatch(clearNewStatement());
    clearOptions();
    setDefaultOptions();
  };

  const setOptionsFromLibs = () => {
    if (Object.values(dictionaryReducer.identificationDocuments).length > 0) {
      setDocOptionsDocumentsFromDictionariesInterested(dictionaryReducer.identificationDocuments);
      setDocOptionsDocumentsFromDictionariesRepresent(dictionaryReducer.identificationDocuments);
    }
    if (Object.values(dictionaryReducer.allOblast).length > 0) {
      setOblOptionsFromDictionariesInterested(dictionaryReducer.allOblast);
      setOblOptionsFromDictionariesRepresent(dictionaryReducer.allOblast);
    }
    if (Object.values(dictionaryReducer.allEngineTypes).length > 0) {
      setOptionsEngType(dictionaryReducer.allEngineTypes);
    }
    if (
      Object.values(dictionaryReducer.boatTypes).length > 0 &&
      Object.values(dictionaryReducer.kindsBoats).length > 0 &&
      Object.values(dictionaryReducer.allBoatBodyMaterial).length > 0 &&
      Object.values(dictionaryReducer.allSwimmingDifficultyCategory).length > 0
    ) {
      setOptionsForBoat(
        dictionaryReducer.boatTypes,
        dictionaryReducer.kindsBoats,
        dictionaryReducer.allBoatBodyMaterial,
        dictionaryReducer.allSwimmingDifficultyCategory,
      );
    }
    if (
      dictionaryReducer.identificationDocuments &&
      dictionaryReducer.allOblast &&
      dictionaryReducer.allEngineTypes &&
      dictionaryReducer.boatTypes &&
      dictionaryReducer.kindsBoats &&
      dictionaryReducer.allBoatBodyMaterial &&
      dictionaryReducer.allSwimmingDifficultyCategory &&
      mode === "add"
    ) {
      setIsLoading(false);
    }
  };

  const handleClosePassModal = () => {
    setShowPasswordModal(false);
    setButtonType("");
    resetModal();
  };

  const getUserInfoById = async (propsBtnType) => {
    const { persNum, unp, agentPersNum } = getValues();
    const { pw } = getValuesModal();

    const setDataAfterRequest = async (data) => {
      for (const [key, val] of Object.entries(data)) {
        if (val) {
          newData[key] = val;
          setValue(key, val);
        }
      }
      setNewData(structuredClone(newData, getValues()));
    };

    const setOptionsAfterRequest = async (data) => {
      if (data.oblId) {
        setOptions({
          ...options,
          interested: await setOptionsInterestedPerson(data, "oblId", personTypeByPath),
        });
      }
      if (data.rayonId) {
        setOptions({
          ...options,
          interested: await setOptionsInterestedPerson(data, "rayonId", personTypeByPath),
        });
      }
      if (data.agentOblId) {
        setOptions({
          ...options,
          represent: await setOptionsRepresentPerson(data, "agentOblId"),
        });
      }
      if (data.agentRayonId) {
        setOptions({
          ...options,
          represent: await setOptionsRepresentPerson(data, "agentRayonId"),
        });
      }
    };
    if (buttonType) {
      const value = buttonType === "persNum" ? persNum : agentPersNum;
      const key = buttonType;
      if (value) {
        if (!/^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/.test(value)) {
          setError(key, {
            type: "manual",
            message: `Введите номер в формате "0000000A000AA0"`,
          });
          return;
        } else {
          // индификационный номер
          clearErrors(key);
          setIsLoadingModal(true);
          await fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_INFO_BY_PERS_NUM + value, {
            headers: { "Content-Type": "application/json" },
          })
            .then(async (res) => {
              if (!res.ok) {
                throw new Error(`Ошибка сети: ${res.status}`);
              }
              return res.json();
            })
            .then(async (dataForInnerRequest) => {
              let resInner;
              let resWithData;

              try {
                resInner = await fetch(API_FOR_AVEST_SIGN, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ ...dataForInnerRequest, pw: pw }),
                });
              } catch (error) {
                resWithData = await fetchWithToken(
                  MAIN_URL +
                    PORT_FOR_INTEGRATION +
                    API_GET_INFO_BY_PERS_NUM_WITH_SIGN +
                    `${userId}/${value}?agent=${key === "persNum" ? 1 : 2}`,
                  {
                    method: "POST",
                    body: JSON.stringify({
                      headers: null,
                      body: null,
                      identificationNumber: value,
                      log: false,
                    }),
                    headers: { "Content-Type": "application/json" },
                  },
                );
              }
              if (resInner) {
                if (!resInner.ok) {
                  const errorText = await resInner.text();
                  if (errorText === "Invalid container password") {
                    throw new Error(`Ошибка подписи! Неверный пароль.`);
                  }
                  resWithData = await fetchWithToken(
                    MAIN_URL +
                      PORT_FOR_INTEGRATION +
                      API_GET_INFO_BY_PERS_NUM_WITH_SIGN +
                      `${userId}/${value}?agent=${key === "persNum" ? 1 : 2}`,
                    {
                      method: "POST",
                      body: JSON.stringify({
                        headers: null,
                        body: null,
                        identificationNumber: value,
                        log: false,
                      }),
                      headers: { "Content-Type": "application/json" },
                    },
                  );
                } else {
                  const dataWithSign = await resInner.json();

                  resWithData = await fetchWithToken(
                    MAIN_URL +
                      PORT_FOR_INTEGRATION +
                      API_GET_INFO_BY_PERS_NUM_WITH_SIGN +
                      `${userId}/${value}?agent=${key === "persNum" ? 1 : 2}`,
                    {
                      method: "POST",
                      body: JSON.stringify(dataWithSign),
                      headers: { "Content-Type": "application/json" },
                    },
                  );
                }
              }

              const dataWithInformation = await resWithData.json();
              if (!resWithData.ok) {
                throw new Error(dataWithInformation.message);
              } else {
                setOptionsAfterRequest(dataWithInformation);
                setDataAfterRequest(dataWithInformation);
                handleClosePassModal();
              }
            })
            .catch((error) => {
              setErrorText(error.message);
              setHeaderText("Заполните поля вручную или повторите заново");
              setRegistrationResult("error");
              setShowResultModal(true);
              clearErrors(key);
              setIsLoadingModal(false);
            });

          clearErrors(key);
          setIsLoadingModal(false);
        }
      } else {
        setError(key, {
          type: "manual",
          message: "Для поиска заполните поле",
        });
      }
    } else if (propsBtnType) {
      if (unp) {
        if (unp.trim().length !== 9 || !/^[\d]+$/.test(unp)) {
          setError("unp", {
            type: "manual",
            message: "Для поиска введите 9 цифр",
          });
          return;
        } else {
          clearErrors("unp");
          setIsLoadingModal(true);

          const data = await fetchWithToken(
            MAIN_URL + PORT_FOR_INTEGRATION + API_GET_INFO_BY_REG_NUM + `?regNum=${unp}`,
          ).then(async (res) => {
            if (!res.ok) {
              const result = await res.json();
              const errText = result.message;
              setErrorText(errText);
              setHeaderText("Заполните поля вручную");
              setRegistrationResult("error");
              setShowResultModal(true);
              clearErrors("unp");
              setOptions({
                ...options,
                interested: toggleSearchButton(false),
              });
              setIsLoadingModal(false);
            }
            return res.json();
          });

          newData["egrNum"] = getValues("unp");
          setValue("egrNum", getValues("unp"));
          setDataAfterRequest(data);
          setOptionsAfterRequest(data);

          setOptions({
            ...options,
            interested: toggleSearchButton(true),
          });
          clearErrors("unp");
          setNewData(structuredClone(newData));
          setIsLoadingModal(false);
        }
      } else {
        setError("unp", {
          type: "manual",
          message: "Для поиска заполните поле УНП",
        });
      }
    }
  };

  const getBoatInfoByBoatVin = async () => {
    const { boatVin, boatType, boatName } = getValues();
    const error = !boatVin || !boatType || !boatName;
    if (!error) {
      clearErrors("boatVin");
      clearErrors("boatType");
      clearErrors("boatName");
      const req = await fetchWithToken(MAIN_URL + PORT + API_GET_BOAT_INFO_BY_VIN, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ boatName, boatVin, boatType }),
      });

      if (req.ok) {
        const res = await req.json();
        for (let item in res) {
          setValue(item, res[item]);
        }
        handleEngPower(res.engpwrmax, "engpwrmax");
      } else {
        const errText = await req.text();
        const response = JSON.parse(errText);
        setErrorText(response.message);
        setHeaderText("Результат поиска");
        setShowResultModal(true);
      }
    } else {
      if (!boatVin) {
        setError("boatVin", {
          type: "manual",
          message: "Для поиска заполните поле",
        });
      }
      if (!boatType) {
        setError("boatType", {
          type: "manual",
          message: "Для поиска заполните поле",
        });
      }
      if (!boatName) {
        setError("boatName", {
          type: "manual",
          message: "Для поиска заполните поле",
        });
      }
    }
  };

  const handleBoatTypeChange = async () => {
    setTableOptions({
      ...tableOptions,
      ...(await toggleEngDtoListRequired(getValues("boatType"), getValues("engineNum"))),
    });
    dispatch(clearEnginesTable(getValues("boatType")));
  };

  const validateTablesLength = async (data) => {
    const newErrors = { ...tablesErrors };
    if (data.boatType === 2 || data.boatType === 6) {
      if (data.engineNum && Number(data.engineNum) !== 0) {
        if (statementReducer.boatCardAppEngList.length === 0) {
          newErrors.boatCardAppEngDtoList =
            "Заполните таблицу Сведения о подвесных двигателях маломерного судна";
          setTablesErrors(structuredClone({ ...newErrors }));
        } else {
          newErrors.boatCardAppEngDtoList = "";
          setTablesErrors(structuredClone({ ...newErrors }));
        }
      } else {
        newErrors.boatCardAppEngDtoList = "";
        setTablesErrors(structuredClone({ ...newErrors }));
      }
    } else {
      if (statementReducer.boatCardAppEngStaticDtoList.length !== data.engineNum * 1) {
        newErrors.boatCardAppEngStaticDtoList =
          "Количество двигателей в таблице должно соответствовать количеству двигателей, указанному в Сведениях о маломерном судне";
        setTablesErrors(structuredClone({ ...newErrors }));
      } else {
        newErrors.boatCardAppEngStaticDtoList = "";
        setTablesErrors(structuredClone({ ...newErrors }));
      }
    }
    if (statementReducer.boatCardAppDealsList.length === 0) {
      newErrors.boatCardAppDealsDtoList = "Заполните таблицу Сведения о правах собственности";
      setTablesErrors(structuredClone({ ...newErrors }));
    } else {
      newErrors.boatCardAppDealsDtoList = "";
      setTablesErrors(structuredClone({ ...newErrors }));
    }

    if (Object.values(newErrors).find((item) => !!item)) {
      setErrorText("Проверьте правильность заполнения таблиц");
      setHeaderText("Заявление заполнено некорректно");
      setShowResultModal(!showResultModal);
      return false;
    } else {
      setErrorText("");
      setHeaderText("");
      return true;
    }
  };

  const resolveSubmit = async (data) => {
    const { surname, name, midname, phone, isNeedToPaySelector, boatType, engineNum } = getValues();
    if (!isNeedToPaySelector) {
      if (await validateTablesLength(getValues())) {
        handleApplication(data, false);
        return;
      }
    }
    if (await handleApplication(data, true)) {
      if (await validateTablesLength(getValues())) {
        const addressString = `РБ, ${
          getValues("oblId") === 5
            ? "г. Минск"
            : interestedIndividual.inputsOptions.oblId.options.find(
                (item) => item.value === getValues("oblId"),
              )?.label
        }${
          getValues("rayonId")
            ? ", " +
              interestedIndividual.inputsOptions.rayonId.options.find(
                (item) => item.value === getValues("rayonId"),
              )?.label +
              " район"
            : ""
        }${
          getValues("gorodId")
            ? ", " +
              interestedIndividual.inputsOptions.gorodId.options.find(
                (item) => item.value === getValues("gorodId"),
              )?.label
            : ""
        }${getValues("ulica") ? ", ул. " + getValues("ulica") : ""}${
          getValues("dom") ? ", д. " + getValues("dom") : ""
        }${getValues("korpus") ? ", к. " + getValues("korpus") : ""}${
          getValues("kv") ? ", кв. " + getValues("kv") : ""
        }`;

        const createdBill = await fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_BILL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          body: JSON.stringify({
            address: addressString,
            surname,
            name,
            midname,
            programId: null,
            phone,
            paidProcType: null,
            codeNumber: boatType === 6 ? "200001" : "200002",
          }),
        }).then((res) => res.json());

        if (createdBill.id) {
          setHeaderText("");
          fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_QR, {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify({
              serviceBillId: createdBill.serviceBillId,
            }),
          })
            .then((res) => res.blob())
            .then((blob) => {
              setServiceBill({
                id: createdBill.serviceBillId,
                QRurl: URL.createObjectURL(blob),
                onClose: () => {
                  handleApplication({ ...data, billDataId: createdBill.id }, false);
                  setShowBillContractModal(false);
                },
              });
              setShowBillContractModal(true);
            });
        } else {
          setErrorText("Зарегистрируйте заявление без выставления счёта на оплату или попробуйте позже.");
          setHeaderText(createdBill.message);
          setShowResultModal(!showResultModal);
        }
      }
    }
  };

  const handleApplication = async (data, check) => {
    const api =
      check === "file"
        ? API_PRINT_STATEMENT_BOAT
        : check
        ? API_CHECK_POSSIBILITY_SAVING_APP
        : API_ADD_NEW_STATEMENT;
    const formData = new FormData();
    const newStatement = { ...newData, ...data };
    delete newStatement.stranId;
    delete newStatement.agentCountry;

    statementReducer.boatCardAppDealsList.map((item, index) => {
      !check && delete item.innerId;
      Object.entries(item).map((elem) => {
        formData.append(`boatCardAppDealsDtoList[${index}].${elem[0]}`, elem[1]);
      });
      return item;
    });
    statementReducer.boatCardAppEngStaticDtoList.map((item, index) => {
      !check && delete item.innerId;
      Object.entries(item).map((elem) => {
        formData.append(`boatCardAppEngStaticDtoList[${index}].${elem[0]}`, elem[1]);
      });
      return item;
    });
    statementReducer.boatCardAppEngList.map((item, index) => {
      !check && delete item.innerId;
      Object.entries(item).map((elem) => {
        formData.append(`boatCardAppEngDtoList[${index}].${elem[0]}`, elem[1]);
      });
      return item;
    });

    statementReducer.boatCardAppSpecMarkList.map((item, index) => {
      !check && delete item.innerId;
      Object.entries(item).map((elem) => {
        if (elem[0] === "asmLock") {
          formData.append(`boatCardAppSmDtoList[${index}].${elem[0]}`, Boolean(elem[1]));
        } else {
          formData.append(`boatCardAppSmDtoList[${index}].${elem[0]}`, elem[1]);
        }
      });
      return item;
    });
    for (let item in newStatement) {
      if (newStatement[item] === null || newStatement[item] === undefined) {
        delete newStatement[item];
      }
    }
    Object.entries(newStatement).forEach((item) => {
      formData.append(`${item[0]}`, `${item[1]}`);
    });
    formData.append("PersonType", localPersonType);
    if (file) {
      formData.append("file", file);
    }

    try {
      const request = await fetchWithToken(
        `${MAIN_URL}${PORT}${api}${check === "file" ? personTypeByPath : ""}`,
        {
          method: "POST",
          body: formData,
        },
      );

      if (check === "file") {
        const formData = await request.formData();
        const fileDocx = formData.get("docx");
        const fileUrl = URL.createObjectURL(fileDocx);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = fileDocx.name;
        link.click();
        setIsPrinted(true);
        return;
      }

      if (request.status === 200) {
        if (check && check !== "file") {
          return true;
        }
        const response = await request.text();
        setAppId(response);
        setShowResultModal(!showResultModal);
        setRegistrationResult("success");
        await deleteDataFromIndexedDB(storeName, 1);
      } else {
        const response = await request.text();
        await saveDataToIndexedDB(storeName, {
          ...newStatement,
          personType: localPersonType,
        });
        setErrorText(response);
        setShowResultModal(!showResultModal);
        setRegistrationResult("error");
      }
    } catch (error) {
      await saveDataToIndexedDB(storeName, {
        ...newStatement,
        personType: localPersonType,
      });
      setErrorText("Проверьте соединение с интернетом");
      setShowResultModal(!showResultModal);
      setRegistrationResult("error");

      if (check && check !== "file") {
        return false;
      }
    }
  };

  const handleDownloadFile = async (e) => {
    if (e) {
      e.preventDefault();
      if (await trigger()) {
        if (await validateTablesLength(getValues())) {
          if (await handleApplication(getValues(), true)) {
            handleApplication(getValues(), "file");
          }
        }
      }
    }
  };

  useEffect(() => {
    const asyncWatch = async (value, { name, type }) => {
      if (type !== undefined) {
        if (newData[name] !== value[name]) {
          newData[name] = value[name];
          if (name === "agentOblId" || name === "agentRayonId" || name === "agentGorodId") {
            setOptions({
              ...options,
              represent: await setOptionsRepresentPerson(value, name, localPersonType),
            });
            if (name === "agentOblId") {
              setValue("agentRayonId", undefined);
              setValue("agentGorodId", undefined);
            }
          }
          if (name === "oblId" || name === "rayonId" || name === "gorodId") {
            setOptions({
              ...options,
              interested: await setOptionsInterestedPerson(value, name, localPersonType),
            });
            if (name === "oblId") {
              setValue("rayonId", undefined);
              setValue("gorodId", undefined);
            }
          }
        }
        if (name === "docType") {
          setOptions({
            ...options,
            interested: setMidnameRequiredByDocType(value[name]),
          });
          clearErrors("midname");
        }
        if ((name === "engpwrmaxkwt" || name === "engpwrmax") && value[name])
          handleEngPower(value[name], name);
        if (name === "boatType" || name === "engineNum") handleBoatTypeChange();
        if (name === "engineNum") {
          setOptions({
            ...options,
            boatInfo: toggleRequiredEngPowerByEngineNum(value[name]),
          });
        }
        if (name === "boatType") {
          setOptions({
            ...options,
            boatInfo: toggleRequiredEngPowerByBoatType(value[name]),
          });
        }
      }
    };
    const subscription = watch(asyncWatch);
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    setOptionsFromLibs();
  }, [dictionaryReducer]);

  useEffect(() => {
    setOptionsFromLibs();
  }, []);

  useEffect(() => {
    if (mode === "view") {
      const pathArray = window.location.pathname.split("/");
      const id = pathArray[pathArray.length - 1];
      dispatch(getBoatRegInfo(id));
    }
  }, []);

  useEffect(() => {
    setValue("isNeedToPaySelector", newData.isNeedToPaySelector);
  }, []);

  useEffect(() => {
    if (Object.values(statementReducer.newStatement)) {
      setNewData({ ...newData, ...statementReducer.newStatement });
      if (statementReducer.newStatement.hasOwnProperty("agent")) {
        setOptions({
          ...options,
          represent: setDefaultOptionsRepresent(
            mode,
            !!statementReducer.newStatement?.agent,
            !!statementReducer.newStatement?.agentOblId,
          ),
        });
      }
    }
    setIsLoading(false);
  }, [statementReducer.newStatement]);

  useEffect(() => {
    async function setoptionsInterested(value, key, type) {
      setOptions({
        ...options,
        interested: await setOptionsInterestedPerson(value, key, type),
      });
    }
    async function setoptionsRepresent(value, key) {
      setOptions({
        ...options,
        represent: await setOptionsRepresentPerson(value, key),
      });
    }
    if (mode === "view") {
      if (!!newData.oblId && localPersonType) {
        setoptionsInterested(newData, "oblId", localPersonType);
      }
      if (!!newData.rayonId && localPersonType) {
        setoptionsInterested(newData, "rayonId", localPersonType);
      }
      if (!!newData.agentOblId) {
        setoptionsRepresent(newData, "agentOblId");
      }
      if (!!newData.agentRayonId) {
        setoptionsRepresent(newData, "agentRayonId");
      }
    }
  }, [newData.oblId, newData.rayonId, newData.agentOblId, newData.agentRayonId, localPersonType]);

  useEffect(() => {
    if (mode === "add") {
      Object.values(options).map((item) => {
        item.inputsOptions &&
          Object.values(item.inputsOptions).map((elem) => {
            if (elem.defaultValue) {
              setValue(elem.key, elem.defaultValue);
            }
          });
      });
    } else {
      Object.values(options).map((item) => {
        item.inputsOptions &&
          Object.values(item.inputsOptions).map((elem) => {
            if (elem.hasOwnProperty("defaultValue")) {
              newData[elem.key] = elem.defaultValue;
            }
          });
        setNewData(structuredClone(newData));
      });
    }
  }, [options]);

  useEffect(() => {
    if (localPersonType) {
      setOptions({ ...setGridsByMode(mode, localPersonType) });
    }
  }, [localPersonType]);

  useEffect(() => {
    if (statementReducer.personType) {
      setLocalPersonType(statementReducer.personType);
    }
  }, [statementReducer.personType]);

  useEffect(() => {
    return () => {
      handleCloseApp();
    };
  }, []);

  useEffect(() => {
    if (localPersonType === 2) {
      setOptions({
        ...options,
        interested: setButtonVisibilityByAccess(searchAccess),
      });
    }
  }, [searchAccess]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await logIndexedDBData(storeName);
      setIndexedDBData(data);
    };

    fetchData();
  }, [storeName]);

  useEffect(() => {
    if (
      indexedDBData &&
      indexedDBData[0] &&
      indexedDBData[0]?.data &&
      indexedDBData[0]?.data.personType === localPersonType
    ) {
      const DBData = indexedDBData[0].data;
      const setData = async () => {
        if (DBData.oblId) {
          DBData.stranId = "Республика Беларусь";
          setOptions({
            ...options,
            interested: await setOptionsInterestedPerson(DBData, "oblId", localPersonType),
          });
        }
        if (DBData.rayonId) {
          setOptions({
            ...options,
            interested: await setOptionsInterestedPerson(DBData, "rayonId", localPersonType),
          });
        }
        if (DBData.agentOblId) {
          setOptions({
            ...options,
            represent: await setOptionsRepresentPerson(DBData, "agentOblId"),
          });
        }
        if (DBData.agentRayonId) {
          setOptions({
            ...options,
            represent: await setOptionsRepresentPerson(DBData, "agentRayonId"),
          });
        }

        setNewData({ ...newData, ...DBData });
        reset(DBData);
      };

      setData();
    }
  }, [indexedDBData]);

  return (
    <>
      <div className={styles["content-container"]}>
        <h1 className={styles["main-text"]}>Заявление</h1>
        <p className={styles["description-text"]}>
          {localPersonType === 1
            ? "о государственной регистрации и классификации маломерных судов, за исключением гребных лодок, байдарок и надувных судов грузоподъемностью менее 225 килограммов"
            : "о государственной регистрации и классификации маломерного судна"}
        </p>
        {isLoading ? (
          <div className={`d-flex flex-column align-items-center `}>
            <ProgressBar
              height="80"
              width="80"
              ariaLabel="progress-bar-loading"
              wrapperStyle={{}}
              wrapperClass="progress-bar-wrapper"
              borderColor="#D2AF8E"
              barColor="#BC8653"
            />
          </div>
        ) : (
          <form onSubmit={handleSubmit(resolveSubmit)}>
            <UniversalInputComponent
              options={options.interested}
              mode={mode}
              styles={styles}
              register={register}
              newData={newData}
              control={control}
              setValue={setValue}
              errors={errors}
              clearErrors={clearErrors}
              handleCustomButton={(e) => {
                if (e.currentTarget.dataset.key === "persNum") {
                  if (!/^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/.test(getValues("persNum"))) {
                    setError("persNum", {
                      type: "manual",
                      message: `Введите номер в формате "0000000A000AA0"`,
                    });
                  } else {
                    setButtonType(e.currentTarget.dataset.key);
                    setShowPasswordModal(true);
                  }
                } else {
                  getUserInfoById(e.currentTarget.dataset.key);
                }
              }}
            />
            <UniversalInputComponent
              options={options.represent}
              mode={mode}
              styles={styles}
              register={register}
              newData={newData}
              control={control}
              setValue={setValue}
              errors={errors}
              clearErrors={clearErrors}
              handleCustomButton={(e) => {
                if (!/^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/.test(getValues("agentPersNum"))) {
                  setError("agentPersNum", {
                    type: "manual",
                    message: `Введите номер в формате "0000000A000AA0"`,
                  });
                } else {
                  setButtonType(e.currentTarget.dataset.key);
                  setShowPasswordModal(true);
                }
              }}
            />
            <UniversalInputComponent
              options={options.boatInfo}
              mode={mode}
              styles={styles}
              register={register}
              newData={newData}
              control={control}
              setValue={setValue}
              errors={errors}
              clearErrors={clearErrors}
              handleCustomButton={getBoatInfoByBoatVin}
            />
            {((mode === "view" && statementReducer.boatCardAppEngStaticDtoList.length > 0) ||
              tableOptions.boatCardAppEngStaticDtoList.required) && (
              <TableAppBoatRegRHF
                appData={getValues()}
                typeTable={"boatCardAppEngStaticDtoList"}
                tableOptions={tableOptions.boatCardAppEngStaticDtoList}
                mode={mode}
                addAccess={
                  true &&
                  getValues("engpwrmaxkwt") &&
                  getValues("engineNum") > statementReducer.boatCardAppEngStaticDtoList.length
                }
                error={tablesErrors.boatCardAppEngStaticDtoList}
                tooltipText={
                  mode !== "view" &&
                  "Для добавления двигателей заполните количество и предельную мощность в Сведениях о маломерном судне"
                }
              />
            )}
            <OtherInformationRHF
              mode={mode}
              register={register}
              newData={newData}
            />
            {((mode === "view" && statementReducer.boatCardAppEngList.length > 0) ||
              tableOptions.boatCardAppEngDtoList.needInForm) && (
              <TableAppBoatRegRHF
                appData={getValues()}
                typeTable={"boatCardAppEngList"}
                tableOptions={tableOptions.boatCardAppEngDtoList}
                mode={mode}
                addAccess={true && getValues("engpwrmaxkwt")}
                error={tablesErrors.boatCardAppEngDtoList}
                tooltipText={
                  mode !== "view" &&
                  "Для добавления двигателей заполните количество и предельную мощность в Сведениях о маломерном судне"
                }
              />
            )}
            <TableAppBoatRegRHF
              typeTable={"boatCardAppDealsList"}
              tableOptions={tableOptions.boatCardAppDealsDtoList}
              mode={mode}
              addAccess={true}
              tooltipText={
                mode !== "view" &&
                "Укажите договор купли-продажи, дарения, свидетельство о праве на наследство и пр. документы"
              }
              error={tablesErrors.boatCardAppDealsDtoList}
            />
            <TableAppBoatRegRHF
              typeTable={"boatCardAppSpecMarkList"}
              tableOptions={tableOptions.boatCardAppSmDtoList}
              mode={mode}
              addAccess={true}
              tooltipText={mode !== "view" && "Укажите сведения о долях собственности, иные ограничения"}
            />
            {mode === "add" && window.location.pathname.includes("individual") && (
              <div className={styles["exam-type-block"]}>
                <InputsCreatorUniversal
                  option={isNeedToPaySelector}
                  styles={styles}
                  register={register}
                  newData={newData}
                  control={control}
                  setValue={setValue}
                  mode={mode}
                  errors={errors}
                  clearErrors={clearErrors}
                />
              </div>
            )}
            <AppFooterRHF
              mode={mode}
              register={register}
              control={control}
              setValue={setValue}
              clearErrors={clearErrors}
              errors={errors}
              newData={newData}
              styles={styles}
              handleFile={handleFile}
              clearFile={clearFile}
              fileName={file?.name}
              fileDownloadApi={downloadAPI}
              viewFileName={viewFileName}
            />
            <ButtonsBlock
              closeBtnText={!isPrinted && "Закрыть"}
              saveBtnText={mode === "add" && "Зарегистрировать"}
              extraBtnText={mode === "add" && printAccess && "Распечатать"}
              handleCloseBtn={() => {
                handleCloseApp();
                navigate("/smallboatsreg");
              }}
              handleExtraBtn={handleDownloadFile}
            />
          </form>
        )}
      </div>
      <ModalWindowWithInputs
        showModal={showPasswordModal}
        setShowModal={handleClosePassModal}
        textButton={"Найти"}
        externalStyles={styles}
        inputsOptions={optionsForPasswordModal}
        mode={"add"}
        handleSubmit={handleSubmitModal}
        register={registerModal}
        control={controlModal}
        setValue={setValueModal}
        errors={errorsModal}
        clearErrors={clearErrors}
        handle={getUserInfoById}
        isLoadingModal={isLoadingModal}
      />
      {showBillContractModal && (
        <QRModalWindow
          show={showBillContractModal}
          setShow={setShowBillContractModal}
          billId={serviceBill.id}
          billQRurl={serviceBill.QRurl}
          onClose={serviceBill.onClose}
        />
      )}
      {showResultModal && (
        <ResultModalWindow
          appId={appId}
          show={showResultModal}
          setShow={setShowResultModal}
          result={registrationResult}
          handleCloseApp={() => {
            navigate("/smallboatsreg");
            handleCloseApp();
          }}
          errorText={errorText}
          headerTextExternal={headerText}
        />
      )}
    </>
  );
}
